import { GmdGapOverviewData } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gmdGapOverviewData";
import { QesColors } from "@app/shared/qes-standards/colors";

export const mockGapOverviewData: GmdGapOverviewData = {
  barData: {
    segments: [
      {
        backgroundColor: QesColors.QesTertiaryYellow2,
        label: "Access",
        numberValue: 775,
      },
      {
        backgroundColor: QesColors.QesTertiaryRed2,
        label: "Servicing",
        numberValue: 500,
      },
      {
        backgroundColor: QesColors.QesPrimaryRed,
        label: "Both",
        numberValue: 207,
      },
    ]
  },
  exceptions: 224,
  members: 38420,
  newGaps: -24,
};
